/**
 * Controls which totals columns are appended to the query result.
 *
 * - NONE   → no totals, GROUP BY only.
 * - TOTALS → adds `<metric>___totals` (grand total only). Use with single-dimension GROUP BY.
 * - ALL    → adds subtotals per dimension group + grand total. Use with multi-dimension GROUP BY.
 */
export enum EGroupWithClause {
  NONE = '',
  TOTALS = 'TOTALS',
  ALL = 'WITH GROUP_TOTALS, TOTALS',
}
